import { ThemeProvider } from '@mui/material/styles';
import { activeTheme, createAppTheme } from './styles/styles';
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { AuthProvider }     from "./context/AuthContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import './App.css';

// Components
import ButtonAppBar     from "./ButtonAppBar";
import Footer           from "./components/Footer";
import Home             from "./components/Home";
import Login            from "./components/Login";
import Register         from "./components/Register";
import Logout           from "./components/Logout";
import TourDetails      from './components/TourDetails';
import CreateTour       from './components/CreatTour';
import Checkout         from './components/Checkout';
import Profile          from './components/Profile';
import BookingDetails   from './components/BookingDetails';
import MyBookings       from "./components/MyBookings";
import ManagerDashboard from "./components/ManagerDashboard";
import ConfirmEmail from "./components/ConfirmEmail";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import UserManagement  from "./components/UserManagement";
import DistrictList    from "./components/DistrictList";
import DistrictDetails from "./components/DistrictDetails";
import CreateDistrict    from "./components/CreateDistrict";
import GuideProfilePage   from "./components/GuideProfilePage";
import ManagerProfilePage from "./components/ManagerProfilePage";
import CreateBicycle      from "./components/CreateBicycle";
import RentalBookingPage   from "./components/RentalBookingPage";
import TourOffers          from "./components/TourOffers";
import ToursPage           from "./components/ToursPage";
import RentalsPage         from "./components/RentalsPage";
import GuideDashboard      from "./components/GuideDashboard";
import DistrictOpsPage     from "./components/DistrictOpsPage";
import CreateBikeTravelOffer    from "./components/CreateBikeTravelOffer";
import BikeTravelOfferList      from "./components/BikeTravelOfferList";
import BikeTravelOfferDetails        from "./components/BikeTravelOfferDetails";
import BikeTravelBookingSuccess      from "./components/BikeTravelBookingSuccess";
import RentalsEdit              from "./components/RentalsEdit";
import AboutUs                  from "./components/AboutUs";
import Contact                  from "./components/Contact";
import PrivacyPolicy            from "./components/PrivacyPolicy";
import TermsOfService           from "./components/TermsOfService";
import FaqPage                  from "./components/FaqPage";
import OAuthCallback             from "./components/OAuthCallback";

// Handles Supabase emailing the token to the root URL instead of /reset-password
// when the redirectTo was not set (e.g. old emails or wrong Supabase site URL config)
function RecoveryHashRedirect() {
    const navigate = useNavigate();
    useEffect(() => {
        const params = new URLSearchParams(window.location.hash.substring(1));
        if (params.get("type") === "recovery" && params.get("access_token")) {
            navigate("/reset-password" + window.location.hash, { replace: true });
        }
    }, [navigate]);
    return null;
}

function App() {
    const muiTheme = createAppTheme();

    useEffect(() => {
        const root = document.documentElement;
        Object.entries(activeTheme).forEach(([key, value]) => {
            root.style.setProperty(key, value);
        });
    }, []);

    return (
        <ThemeProvider theme={muiTheme}>
            <CurrencyProvider>
            <AuthProvider>
                <div className="App">
                    <BrowserRouter>
                        <RecoveryHashRedirect />
                        <ButtonAppBar />
                        <main>
                            <Routes>
                                <Route path="/"              element={<Home />} />
                                <Route path="/register"      element={<Register />} />
                                <Route path="/login"         element={<Login />} />
                                <Route path="/logout"        element={<Logout />} />
                                {/* /tours/create MUST be declared before /tours/:id
                                    so React Router doesn't treat "create" as a UUID param */}
                                <Route path="/tours"         element={<TourOffers />} />
                                <Route path="/tours/create"  element={<CreateTour />} />
                                <Route path="/tours/:id"     element={<TourDetails />} />
                                <Route path="/rentals"       element={<RentalBookingPage />} />
                                <Route path="/checkout/:id"  element={<Checkout />} />
                                <Route path="/profile"       element={<Profile />} />
                                <Route path="/my-bookings"   element={<MyBookings />} />
                                <Route path="/booking/:id"   element={<BookingDetails />} />
                                <Route path="/dashboard"     element={<ManagerDashboard />} />
                                <Route path="/confirm-email" element={<ConfirmEmail />} />
                                <Route path="/forgot-password" element={<ForgotPassword />} />
                                <Route path="/reset-password" element={<ResetPassword />} />
                                <Route path="/users"           element={<UserManagement />} />
                                <Route path="/guides/:id"          element={<GuideProfilePage />} />
                                <Route path="/managers/:id"        element={<ManagerProfilePage />} />
                                <Route path="/districts"                    element={<DistrictList />} />
                                <Route path="/districts/create"            element={<CreateDistrict />} />
                                <Route path="/districts/:id"               element={<DistrictDetails />} />
                                <Route path="/bicycles/create"             element={<CreateBicycle />} />
                                <Route path="/staff/tours"                 element={<ToursPage />} />
                                <Route path="/staff/rentals"               element={<RentalsPage />} />
                                <Route path="/rental-prices"               element={<RentalsEdit />} />
                                <Route path="/guide/dashboard"             element={<GuideDashboard />} />
                                <Route path="/district-ops"                element={<DistrictOpsPage />} />
                                <Route path="/bike-travel-offers"          element={<BikeTravelOfferList />} />
                                <Route path="/bike-travel-offers/create"      element={<CreateBikeTravelOffer />} />
                                <Route path="/bike-travel-booking/success"   element={<BikeTravelBookingSuccess />} />
                                <Route path="/bike-travel-offers/:id"         element={<BikeTravelOfferDetails />} />
                                <Route path="/about"   element={<AboutUs />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/privacy" element={<PrivacyPolicy />} />
                                <Route path="/terms"   element={<TermsOfService />} />
                                <Route path="/faq"          element={<FaqPage />} />
                                <Route path="/oauth-callback" element={<OAuthCallback />} />
                            </Routes>
                        </main>
                        <Footer />
                    </BrowserRouter>
                </div>
            </AuthProvider>
            </CurrencyProvider>
        </ThemeProvider>
    );
}

export default App;